export type GameControlPhase =
  | 'key9_in_progress'
  | 'key9_practice'
  | 'key9_unlocked'
  | 'key9_missed'
  | 'key9_practice_complete'
  | 'full_in_progress'
  | 'full_done'
  | 'active';

export type GameControlAction = {
  id: 'undo' | 'erase' | 'notes' | 'hint';
  label: string;
  icon: string;
};

export type ResetBoardAction = {
  visible: boolean;
  label: 'Reset Board';
  placement: 'hidden' | 'near_toolbar';
};

export type GameControlState = {
  visible: boolean;
  mode: 'hidden' | 'full';
  placement: 'hidden' | 'above_number_pad';
  layout?: {
    instructionY: number;
    toolbarTopY: number;
    numberPadY: number;
  };
  actions: GameControlAction[];
  resetBoardAction: ResetBoardAction;
};

export const FULL_SUDOKU_INPUT_LAYOUT = {
  instructionY: 414,
  toolbarTopY: 428,
  numberPadY: 506
};

const FULL_ACTIONS: GameControlAction[] = [
  { id: 'undo', label: 'Undo', icon: '↶' },
  { id: 'erase', label: 'Erase', icon: '⌫' },
  { id: 'notes', label: 'Notes', icon: '✎' },
  { id: 'hint', label: 'Hint', icon: '?' }
];

const HIDDEN_RESET_BOARD: ResetBoardAction = {
  visible: false,
  label: 'Reset Board',
  placement: 'hidden'
};

export function getGameControlState(phase: GameControlPhase): GameControlState {
  if (phase === 'full_in_progress') {
    return {
      visible: true,
      mode: 'full',
      placement: 'above_number_pad',
      layout: FULL_SUDOKU_INPUT_LAYOUT,
      actions: FULL_ACTIONS,
      resetBoardAction: {
        visible: true,
        label: 'Reset Board',
        placement: 'near_toolbar'
      }
    };
  }

  return {
    visible: false,
    mode: 'hidden',
    placement: 'hidden',
    actions: [],
    resetBoardAction: HIDDEN_RESET_BOARD
  };
}
